import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import './styles/index.css'

// Дружелюбный экран на случай фатального сбоя при загрузке. Технические детали
// (сообщение, файл, строка, стек) уходят ТОЛЬКО в консоль — для отладки через
// remote-инспектор на Android; пользователю их не показываем.
function showFatalScreen() {
  const root = document.getElementById('root')
  // Не затираем уже отрисованный интерфейс: если приложение успело смонтироваться,
  // разовая ошибка не должна стирать рабочий экран.
  if (!root || root.childElementCount > 0) return
  root.innerHTML = `
    <div style="color: #EEEEFF; padding: 24px; background: #0A0A0F; font-family: 'Geist', -apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif; line-height: 1.5; min-height: 100vh; display: flex; flex-direction: column; justify-content: center; align-items: center; text-align: center;">
      <h1 style="font-size: 19px; margin: 0 0 12px; font-weight: 600;">Не удалось загрузить</h1>
      <p style="font-size: 14px; opacity: 0.6; max-width: 300px; margin: 0 0 20px;">
        Попробуй перезапустить приложение. Если не помогает — напиши в поддержку, поможем.
      </p>
      <a href="https://t.me/zakharovsemyon" style="display: inline-flex; align-items: center; justify-content: center; height: 44px; padding: 0 24px; background: linear-gradient(135deg, #5B7FFF 0%, #4A6CF7 100%); color: #fff; border-radius: 12px; font-size: 15px; font-weight: 500; text-decoration: none;">
        Написать в поддержку
      </a>
    </div>
  `
}

// Синхронные ошибки верхнего уровня, из-за которых приложение могло не
// смонтироваться, — показываем экран, детали в консоль.
window.onerror = (msg, src, line, col, err) => {
  console.error('Global error:', { msg, src, line, col, err })
  showFatalScreen()
  return true
}

// Unhandled promise rejections обычно НЕ фатальны (оборванный запрос при
// навигации, отклонённый колбэк SDK и т.п.) — логируем в консоль, но интерфейс
// не трогаем, чтобы одна фоновая ошибка не стирала рабочий экран.
window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason)
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
)